/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalculator = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 2h18v20H3V2zm2 2v16h14V4H5zm4 10H7v-2h2v2zm4 0h-2v-2h2v2zm2 4v-6h2v6h-2zm-6 0H7v-2h2v2zm4 0h-2v-2h2v2z"
        fill="currentcolor"
      />
      <path d="M7 6h10v4H7V6z" fill="currentcolor" />
    </g>
  </Icon>
);
export { SvgCalculator as Calculator };
